import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-big-calendar'
import TimeGrid from 'react-big-calendar/lib/TimeGrid'

const EasyCalWeek = ({
  date,
  localizer,
  max = localizer.endOf(new Date(), 'day'),
  // max = localizer.endOf(new Date(), 'week'),
  min = localizer.startOf(new Date(), 'day'),
  // min = localizer.startOf(new Date(), 'week'),
  scrollToTime = localizer.startOf(new Date(), 'day'),
  ...props
}) => {
  const currRange = useMemo(
    () => EasyCalWeek.range(date, { localizer }),
    [date, localizer]
  )

  return (
      <TimeGrid
        date={date}
        eventOffset={15}
        localizer={localizer}
        max={max}
        min={min}
        range={currRange}
        scrollToTime={scrollToTime}
        {...props}
      />
  )
}

export default EasyCalWeek;

EasyCalWeek.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  localizer: PropTypes.object,
  max: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  scrollToTime: PropTypes.instanceOf(Date),
}

EasyCalWeek.range = (date, { localizer }) => {
  // const start = date;
  const start = localizer.startOf(date, 'week');
  const today = date;
  // const end = localizer.add(start, 6, 'day');
  const end = localizer.endOf(date, 'week');

  let current = start;
  // let current = today;
  const range = [];

  while (localizer.lte(current, end, 'day')) {
    range.push(current);
    current = localizer.add(current, 1, 'day');
  }

  return range;
}

EasyCalWeek.navigate = (date, action, { localizer }) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return localizer.add(date, -7, 'day');

    case Navigate.NEXT:
      return localizer.add(date, 7, 'day');

    default:
      return date;
  }
}

EasyCalWeek.title = (date, { localizer }) => {
  const [start, ...rest] = EasyCalWeek.range(date, { localizer });
  return localizer.format({ start, end: rest.pop() }, 'dayRangeHeaderFormat');
}